import { render, staticRenderFns } from "./ByEffect.vue?vue&type=template&id=64df9c11&"
import script from "./ByEffect.vue?vue&type=script&lang=js&"
export * from "./ByEffect.vue?vue&type=script&lang=js&"
import style0 from "./ByEffect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports